(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("CQB", [], factory);
	else if(typeof exports === 'object')
		exports["CQB"] = factory();
	else
		root["CQB"] = factory();
})(self, function() {
return 